// Global cap on concurrent resource uploads (Spec 013, 7.4). Shared across all
// composer attachment chips; extra uploads queue until a slot frees.
const MAX_CONCURRENT_UPLOADS = 10

let activeCount = 0
const waiters: Array<() => void> = []

export type ReleaseSlot = () => void

export const acquireUploadSlot = (): Promise<ReleaseSlot> =>
  new Promise((resolve) => {
    const grant = () => {
      activeCount++
      let released = false
      resolve(() => {
        if (released) return
        released = true
        activeCount--
        waiters.shift()?.()
      })
    }
    if (activeCount < MAX_CONCURRENT_UPLOADS) {
      grant()
    } else {
      waiters.push(grant)
    }
  })
